<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="496")
  yz-card
    yz-dialog-normal-header(title="Unassign branch from HQ service" :disable-close="isLoading" @close="onCloseDialog")
    yz-dialog-normal-content
      .pt-4
        .d-flex.align-center.gap-2
          v-icon(color="danger500" size="20") $yzi-alert-circle-solid
          .yz-medium-body-md.text-neutral-700 {{ headline }}
        .yz-regular-body-sm.text-neutral-700.mt-4 {{ description }}
        .yz-regular-body-sm.text-neutral-700.mt-4 You can't undo this action. Click 'Confirm' to proceed.
    yz-dialog-normal-actions(justify="space-between")
      yz-btn(size="lg" text text-color="yz-neutral-700" label="Cancel" :disabled="isLoading" @click="onCancel")
      yz-btn(size="lg" color="danger" label="Confirm" :loading="isLoading" @click="onConfirm")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UnassignBranchConfirmDialog',
  props: {
    value: { type: Boolean, default: false },
    branchId: { type: [Number, String], default: null },
    branchName: { type: String, default: '' },
    serviceId: { type: [Number, String], default: null },
    companySlug: { type: String, default: '' },
    appointmentIds: { type: Array, default: () => [] },
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    showDialog: {
      get () { return this.value },
      set (val) { this.$emit('input', val) },
    },
    hasAppointments () {
      return this.appointmentIds.length > 0
    },
    headline () {
      return this.hasAppointments
        ? 'Are you sure you want to cancel all appointments?'
        : 'Are you sure you want to unassign this branch?'
    },
    description () {
      return this.hasAppointments
        ? 'All upcoming appointments at this location will be cancelled. Please inform branch to take further actions.'
        : 'This service will no longer be available at this branch.'
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async onConfirm () {
      this.isLoading = true
      try {
        if (this.appointmentIds.length > 0) {
          await this.$axios.post(`/clinics/${this.companySlug}/hq/appointments/bulk_cancel`, {
            ids: this.appointmentIds,
            cancelled_reason: 'Service unassigned from branch',
          })
        }
        this.$emit('confirmed', { branchId: this.branchId })
        this.showDialog = false
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    onCloseDialog () {
      if (this.isLoading) return
      this.showDialog = false
    },
    onCancel () {
      if (this.isLoading) return
      this.$emit('cancel')
      this.showDialog = false
    },
  },
}
</script>
